import { Component, OnInit } from "@angular/core";
import { TypeEventOperationHistory } from "@edp-enums/type-event-operation.enum";
import { PaymentAgreement, SelectedComponentEnum } from "@edp-models/edp-payment-agreement.model";
import { AgreementCheckout, AgreementEligibilityError } from "@edp-models/edp-payment.model";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { EdpSteperService } from "@edp-services/edp-steper.service";
import { NifService } from "@edp-services/nif.service";
import { PaymentService } from "@edp-services/payment.service";
import { ShowLoader } from "@edp-store/actions/layout.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import moment from "moment";
import { Subject, interval, of } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "payment-agreement-term",
    templateUrl: "./payment-agreement-term.component.html",
    styleUrls: ["./payment-agreement-term.component.scss"],
})
export class PaymentAgreementTermComponent implements OnInit {
    public paymentAgreementTerm: PaymentAgreement;
    public timer: number;
    public nif: string;
    public accountId: string;
    private timerInterval$: any;
    private destroy$: Subject<void> = new Subject<void>();
    public fireRedirect: boolean = true;

    public CALL_STATUS_INTERVAL = 5000;
    public REDIRECT_AFTER_INTERVAL = 150000;

    constructor(
        private edpPaymentAgreementService: EdpPaymentAgreementService,
        private steperService: EdpSteperService,
        private paymentService: PaymentService,
        private store: Store<IAppState>,
        private nifService: NifService
    ) {
        this.paymentAgreementTerm = this.edpPaymentAgreementService.getPaymentAgreementTerm();
        this.nif = this.nifService.getNifValue().value;
        this.accountId = this.edpPaymentAgreementService.getAccount();
    }

    ngOnInit(): void {
        this.steperService.setActiveStep(3);

        this.edpPaymentAgreementService.paymentAgreementTerm.subscribe((paymentAgreement: PaymentAgreement) => {
            this.paymentAgreementTerm = paymentAgreement;
            if (this.paymentAgreementTerm?.data.dateExpirate) {
                const expirateDate = moment(this.paymentAgreementTerm?.data.dateExpirate);
                this.timer = expirateDate.diff(moment(), "minutes");
                this.setTimer(expirateDate);
            }
        });
    }

    ngOnDestroy() {
        this.destroyRedirectProcess();
    }

    public destroyRedirectProcess() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setTimer(expirateDate) {
        const resInterval = setInterval(() => {
            const updatedDifference = expirateDate.diff(moment(), "minutes");
            if (updatedDifference <= 0) {
                return clearInterval(resInterval);
            } else {
                this.timer = updatedDifference;
            }
        }, 1000);
    }

    redirect(from: string) {
        this.store.dispatch(new ShowLoader(true));
        const accountNumber = this.paymentAgreementTerm.data.accountNumber.toString();
        const args = {
            nif: this.nif,
            account: this.paymentAgreementTerm.data.accountNumber,
        };

        if (from === "accept") {
            this.setOperationHistory(this.nif, accountNumber, TypeEventOperationHistory.CLICKSTEP3ACCEPTAGREEMENT);
            this.paymentService.agreementConfirmation(args).subscribe(res => {
                const response = res[0];

                if (!!response.status) {
                    this.callStatusServiceInterval(args, response);
                } else {
                    this.destroyRedirectProcess();
                    this.fireRedirect = false;
                    this.store.dispatch(new ShowLoader(false));
                    this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.GENERIC_ERROR);
                }
            });
        }

        if (from === "decline") {
            this.setOperationHistory(this.nif, accountNumber, TypeEventOperationHistory.CLICKSTEP3REJECTAGREEMENT);
            this.paymentService.agreementReject(args).subscribe(() => {
                this.store.dispatch(new ShowLoader(false));
                this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.REJECT_AGREEMENT);
            });
        }
    }

    public callStatusServiceInterval(args: any, agreementConfirmationRes: any) {
        this.timerInterval$ = interval(this.CALL_STATUS_INTERVAL)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.paymentService.agreementCheckout(args).subscribe((res: any) => {
                    const statusRes = res[0];
                    if (statusRes.code !== 2) {
                        this.destroyRedirectProcess();
                        this.fireRedirect = false;
                        if (
                            statusRes.data.error === AgreementEligibilityError.E010 ||
                            statusRes.data.error === AgreementEligibilityError.E011 ||
                            statusRes.data.error === AgreementEligibilityError.E012 ||
                            statusRes.data.error === AgreementEligibilityError.E013
                        ) {
                            this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.CONFIRMATION_ERROR);
                            this.store.dispatch(new ShowLoader(false));
                        } else {
                            this.edpPaymentAgreementService.setConfirmationContactResponse(agreementConfirmationRes);
                            this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.ACCEPTANCE_AGREEMENT);
                            this.store.dispatch(new ShowLoader(false));
                        }
                    }
                });
            });

        setTimeout(() => {
            if (this.fireRedirect) {
                this.timerInterval$.unsubscribe();this.store.dispatch(new ShowLoader(false));
                this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.GENERIC_ERROR);
                return;
            }
        }, this.REDIRECT_AFTER_INTERVAL);
    }

    private setOperationHistory(nif: string, account: string, operation: string) {
        this.paymentService.agreementHistory({ nif, account, operation }).subscribe(() => {});
    }
}
